import type { Certification } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useCertification,
  useFind: useCertifications,
  useCreate: useCertificationCreation,
  useUpdate: useCertificationUpdate,
  useDelete: useCertificationDeletion,
} = getCRUDHooks<Certification>({
  entityName: 'certifications',
  getHelper: () => clientApi.getOCClient().helpers.learningContent.certifications,
});

export {
  useCertification,
  useCertifications,
  useCertificationCreation,
  useCertificationUpdate,
  useCertificationDeletion,
};
